import { Routes } from '@angular/router';

import { roleGuard } from '../../core/guards/role.guard';
import { RoleCode } from '../../shared/models/user/user.enums';

export const baseJobsRoutes: Routes = [
	{
		path: 'base-jobs',
		canMatch: [roleGuard],
		data: { allowedRoles: [RoleCode.ADMIN, RoleCode.SUPER_ADMIN] },
		children: [
			{
				path: '',
				loadComponent: () => import('./pages/base-jobs-page/base-jobs-page.component').then(c => c.BaseJobsPageComponent)
			}
		]
	}
];
